import { render, staticRenderFns } from "./Lieqishenheliebiao.vue?vue&type=template&id=5a2e5057&scoped=true&"
import script from "./Lieqishenheliebiao.vue?vue&type=script&lang=js&"
export * from "./Lieqishenheliebiao.vue?vue&type=script&lang=js&"
import style0 from "./Lieqishenheliebiao.vue?vue&type=style&index=0&id=5a2e5057&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2e5057",
  null
  
)

export default component.exports